export class EmaDataRowContentModel {
    public langId: number;
    public eparPlainText: string;
}